import React from "react";
import ControlledCustomTooltip from "../../customTooltip/ControlledCustomTooltip";
import { fetchAllPostPromisedData } from "../../utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../constant";
import { useEffect, useState } from "react";
import ALoader from "../../a-loader";
const UnmaskedPopUp = ({ label, details, encryptedField }) => {
  const [count, setCount] = useState(10);
  const [open, setOpen] = useState(false);
  const [unmaskDialogInfo, setUnmaskDialogInfo] = useState(null);
  const onClose = () => {
    setOpen(false);
  };
  const [loader, setLoader] = useState(false);

  const maskedDetailsHandler = async (details) => {
    try {
      setLoader(true);
      const req = {
        psid: details?.psid,
        applicationId: details?.applicationId,
        encryptedContactNo: details?.[encryptedField],
      };

      const res = await fetchAllPostPromisedData(
        `${endpoint.decryptContact}`,
        req,
      );
      if (res?.code === 200 && res?.data) {
        setUnmaskDialogInfo(res?.data?.contactNo || "");

      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  // Start timer when opened
  useEffect(() => {
    init();
  }, [open]);

  const init = async () => {
    let timer;

    if (open) {
      await maskedDetailsHandler(details);
      setCount(5); // reset

      timer = setInterval(() => {
        setCount((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            setOpen(false); // auto close
            onClose && onClose();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  };

  return (
    <>
      {loader && <ALoader position={"fixed"} />}
      <ControlledCustomTooltip
        showOnClick={true}
        open={open}
        onClose={() => setOpen(false)}
        openHandler={() => setOpen(true)}
        title={
          <div
            style={{
              position: "relative",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
            }}
            className="p-2"
            onCopy={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.preventDefault()}
          >
            {/* Countdown */}
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                color: "red",
                fontWeight: "bold",
                fontSize: "12px",
              }}
              className="semi-bold"
            >
              {count}s
            </div>

            {/* Hint */}
            <div
              style={{
                fontSize: "11px",
                color: "#6c757d",
                marginBottom: "4px",
              }}
            >
              Visible for 5 seconds
            </div>

            {/* Content */}
            <div className="d-flex mt-2 gap-2 align-items-center">
              <div className="semi-bold text-dark">{label}:</div>
              <div className="regular-bold color-dark ">{unmaskDialogInfo}</div>
            </div>
          </div>
        }
      >
        <div
          className="ellipsis-text-container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span
            className="ms-2 cursor-pointer"
            style={{ color: "#0d6efd" }}
            title="View Contact"
          >
            <i className="fa fa-eye" aria-hidden="true"></i>
          </span>
        </div>
      </ControlledCustomTooltip>
    </>
  );
};

export default UnmaskedPopUp;
